import styled from 'styled-components';

export const StyledHeader = styled.header`
	background-color: ${({ theme }) => theme.colors.pictonBlue};
	padding: 40px 0;
	background-repeat: no-repeat;

	/* background-image: url('./images/Colorful-Abstract-Background.svg'); */
`;

export const Nav = styled.nav`
	position: fixed;
	background-color: ${({ theme }) => theme.colors.primary};
	height: 93px;
	width: 100%;
	top: 0;
	/* padding-top: 2px;
	opacity: unset; */
	z-index: 9999;

	box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px,
		rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;

	label.logo {
		img {
			background-color: #fff;
			border-radius: 50%;

			height: 75px;
			margin-left: 8%;
			margin-top: 6px;
		}
		/* font-size: 35px;
		line-height: 80px;
		padding: 0 100px;
		font-weight: bold; */
	}
	ul {
		float: right;
		margin-right: 20px;
	}

	ul li {
		display: inline-block;
		line-height: 80px;
		margin: 0 3px;
	}

	ul li a {
		color: ${({ theme }) => theme.colors.white};
		font-size: 17px;
		padding: 7px 13px;
		border-radius: 5px;
		text-transform: uppercase;
		text-decoration: none;
	}

	a.active,
	a:hover {
		background: ${({ theme }) => theme.colors.primary};
		transition: 0.5s;
		box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
	}

	.checkbtn {
		font-size: 30px;
		color: #fff;
		float: right;
		line-height: 80px;
		margin-right: 40px;
		cursor: pointer;
		display: none;
	}
	#check {
		display: none;
	}

	@media (max-width: ${({ theme }) => theme.tab}) {
		label.logo {
			font-size: 30px;
			padding-left: 40px;
		}
		ul li a {
			font-size: 16px;
		}
	}
	@media (max-width: ${({ theme }) => theme.mobile}) {
		.checkbtn {
			display: block;
			z-index: 100;
		}
		ul {
			position: fixed;
			width: 100%;
			height: 100vh;
			background: ${({ theme }) => theme.colors.secondary};
			color: #fff;
			top: 80px;
			left: -100%;
			text-align: center;
			transition: all 2s;
		}
		ul li {
			display: block;
			margin: 50px 0;
			line-height: 30px;
		}
		ul li a {
			font-size: 20px;
		}

		a:hover,
		a.active {
			background: none;
			color: #0082e6;
		}

		#check:checked ~ ul {
			left: 0;
			z-index: 100;
			cursor: pointer;
		}
	}
`;

export const Logo = styled.div`
	color: ${({ theme }) => theme.colors.primary};
	font-size: 35px;
	line-height: 80px;
	padding: 0 100px;
	font-weight: bold;

	@media (max-width: ${({ theme }) => theme.mobile}) {
		padding-bottom: 40px;
	}
`;

export const Image = styled.img`
	width: 375px;
	margin-left: 40px;
	filter: grayscale(var(--value, 100%));
	border-radius: 15px 0 30px;
	z-index: 0;

	/* 	background-image: url('./images/oldpaperframe.svg'); */
	@media (max-width: ${({ theme }) => theme.mobile}) {
		margin: 40px 0 30px;
	}
`;
